import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import "./LiveotherProducts.css";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

function LiveotherProducts() {
  const [glassesProducts, setGlassesProducts] = useState(null);
  const [watchesProducts, setWatchesProducts] = useState(null);
  const [shoesProducts, setShoesProducts] = useState(null);

  useEffect(() => {
    (async () => {
      const resultGlasses = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/products/v2/list",
        params: {
          store: "US",
          offset: "0",
          categoryId: "29811",
          limit: "48",
          country: "US",
          sort: "freshness",
          currency: "USD",
          sizeSchema: "US",
          lang: "en-US",
        },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });

      setGlassesProducts(resultGlasses.data.products);
      console.log(glassesProducts);

      const resultWatches = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/products/v2/list",
        params: {
          store: "US",
          offset: "0",
          categoryId: "25595",
          limit: "48",
          country: "US",
          sort: "freshness",
          currency: "USD",
          sizeSchema: "US",
          lang: "en-US",
        },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });

      setWatchesProducts(resultWatches.data.products);
      console.log(watchesProducts);

      const resultShoes = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/products/v2/list",
        params: {
          store: "US",
          offset: "0",
          categoryId: "2084",
          limit: "48",
          country: "US",
          sort: "freshness",
          currency: "USD",
          sizeSchema: "US",
          lang: "en-US",
        },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });

      setShoesProducts(resultShoes.data.products);
      console.log(shoesProducts);
    })();
  }, []);

  useEffect(() => {
    console.log(glassesProducts);
    console.log(watchesProducts);
    console.log(shoesProducts);
  }, [glassesProducts, watchesProducts, shoesProducts]);

  return (
    <div className="home-products container ">
      <div id="liveslide" className="carousel slide " data-bs-ride="carousel">
        <div className="carousel-indicators d-none">
          <button
            type="button"
            data-bs-target="#liveslide"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#liveslide"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#liveslide"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div className="carousel-inner">
          {glassesProducts ? (
            <div className="carousel-item active">
              <div className="row">
                <div className="card col-lg-2">
                  <Link to={`/details/${glassesProducts[5].id}`}>
                    <img
                      src={"http://" + glassesProducts[5].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>
                  <div className="card-body">
                    <h4>Glasses</h4>
                    <h5 className="card-title">{glassesProducts[5].name}</h5>
                    <p className="card-text">
                      {glassesProducts[5].price.current.text}
                      <del>{glassesProducts[5].price.previous.text}</del>
                    </p>
                  </div>
                </div>

                <div className="card col-lg-2">
                  <Link to={`/details/${glassesProducts[6].id}`}>
                    <img
                      src={"http://" + glassesProducts[6].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Glasses</h4>
                    <h5 className="card-title">{glassesProducts[6].name}</h5>
                    <p className="card-text">
                      {glassesProducts[6].price.current.text}
                      <del>{glassesProducts[6].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${glassesProducts[7].id}`}>
                    <img
                      src={"http://" + glassesProducts[7].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Glasses</h4>
                    <h5 className="card-title">{glassesProducts[7].name}</h5>
                    <p className="card-text">
                      {glassesProducts[7].price.current.text}
                      <del>{glassesProducts[7].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${glassesProducts[8].id}`}>
                    <img
                      src={"http://" + glassesProducts[8].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Glasses</h4>
                    <h5 className="card-title">{glassesProducts[8].name}</h5>
                    <p className="card-text">
                      {glassesProducts[8].price.current.text}
                      <del>{glassesProducts[8].price.previous.text}</del>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {watchesProducts ? (
            <div className="carousel-item ">
              <div className="row">
                <div className="card col-lg-2">
                  <Link to={`/details/${watchesProducts[0].id}`}>
                    <img
                      src={"http://" + watchesProducts[0].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Watches</h4>
                    <h5 className="card-title">{watchesProducts[0].name}</h5>
                    <p className="card-text">
                      {watchesProducts[0].price.current.text}
                      <del>{watchesProducts[0].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${watchesProducts[3].id}`}>
                    <img
                      src={"http://" + watchesProducts[3].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Watches</h4>
                    <h5 className="card-title">{watchesProducts[3].name}</h5>
                    <p className="card-text">
                      {watchesProducts[3].price.current.text}
                      <del>{watchesProducts[3].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${watchesProducts[1].id}`}>
                    <img
                      src={"http://" + watchesProducts[1].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Watches</h4>
                    <h5 className="card-title">{watchesProducts[1].name}</h5>
                    <p className="card-text">
                      {watchesProducts[1].price.current.text}
                      <del>{watchesProducts[1].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${watchesProducts[2].id}`}>
                    <img
                      src={"http://" + watchesProducts[2].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Watches</h4>
                    <h5 className="card-title">{watchesProducts[2].name}</h5>
                    <p className="card-text">
                      {watchesProducts[2].price.current.text}
                      <del>{watchesProducts[2].price.previous.text}</del>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {shoesProducts ? (
            <div className="carousel-item ">
              <div className="row">
                <div className="card col-lg-2">
                  <Link to={`/details/${shoesProducts[11].id}`}>
                    <img
                      src={"http://" + shoesProducts[11].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Shoes</h4>
                    <h5 className="card-title">{shoesProducts[11].name}</h5>
                    <p className="card-text">
                      {shoesProducts[11].price.current.text}
                      <del>{shoesProducts[11].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${shoesProducts[16].id}`}>
                    <img
                      src={"http://" + shoesProducts[16].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Shoes</h4>
                    <h5 className="card-title">{shoesProducts[16].name}</h5>
                    <p className="card-text">
                      {shoesProducts[16].price.current.text}
                      <del>{shoesProducts[16].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${shoesProducts[21].id}`}>
                    <img
                      src={"http://" + shoesProducts[21].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>

                  <div className="card-body">
                    <h4>Shoes</h4>
                    <h5 className="card-title">{shoesProducts[21].name}</h5>
                    <p className="card-text">
                      {shoesProducts[21].price.current.text}
                      <del>{shoesProducts[21].price.previous.text}</del>
                    </p>
                  </div>
                </div>
                <div className="card col-lg-2">
                  <Link to={`/details/${shoesProducts[20].id}`}>
                    <img
                      src={"http://" + shoesProducts[20].imageUrl}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>
                  <div className="card-body">
                    <h4>Shoes</h4>
                    <h5 className="card-title">{shoesProducts[20].name}</h5>
                    <p className="card-text">
                      {shoesProducts[20].price.current.text}
                      <del>{shoesProducts[20].price.previous.text}</del>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <button
          className="carousel-control-prev "
          type="button"
          data-bs-target="#liveslide"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon bg-dark "
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#liveslide"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon  bg-dark"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default LiveotherProducts;
